import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { BorrowerCharacteristicsStepComponent } from "../../wizard/wizard-steps/borrower-characteristics-step/borrower-characteristics-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class BorrowerCharacteristicsStep extends WizardStepBase {
  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = BorrowerCharacteristicsStepComponent;
  }
}
